import React, { Component } from 'react';
import moment from 'moment';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { CardType } from '../card/card-constants.js';
import './card-date.css';
class CardDate extends Component {
    render() {
        const { className, date, divider, type = CardDate.defaultProps.type, } = this.props;
        const isFeaturedCard = type === CardType.FEATURED;
        const rootClasses = {
            'c-card-date': true,
            'c-card-date--featured': isFeaturedCard,
            [`${className}`]: Boolean(className),
        };
        if (!date) {
            return React.createElement("div", { className: classNames(rootClasses) });
        }
        const momentDate = moment(date).utc();
        const dateParts = [
            momentDate.format('DD'),
            momentDate.format('MMM').toUpperCase(),
            isFeaturedCard ? momentDate.format('HH:mm') : momentDate.format('YYYY'),
        ];
        return (React.createElement("div", { className: classNames(rootClasses) },
            React.createElement("span", { className: "c-card-date__item c-card-date__item--first" }, dateParts[0]),
            React.createElement("div", { className: "c-card-date__group" },
                React.createElement("span", { className: "c-card-date__item c-card-date__item--second" }, dateParts[1]),
                divider && React.createElement("i", { className: "c-card-date__item c-card-date__item--divider" }),
                React.createElement("span", { className: "c-card-date__item c-card-date__item--third" }, dateParts[2]))));
    }
}
CardDate.defaultProps = {
    divider: false,
    type: CardType.DEFAULT,
};
export { CardDate, };
export default CardDate;
//# sourceMappingURL=card-date.js.map